import React from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';

const NewPasswordForm = ({ onSubmit, loading, error }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch('newPassword');

  const handleFormSubmit = (data) => {
    onSubmit(data.newPassword);
  };

  return (
    <Box component="form" onSubmit={handleSubmit(handleFormSubmit)} noValidate>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        margin="normal"
        fullWidth
        label="New Password"
        type="password"
        id="newPassword"
        autoFocus
        {...register('newPassword', {
          required: 'New password is required',
          minLength: {
            value: 8,
            message: 'Password must be at least 8 characters',
          },
          pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/,
            message:
              'Must include uppercase, lowercase, number, and special character',
          },
        })}
        error={!!errors.newPassword}
        helperText={errors.newPassword?.message}
      />

      <TextField
        margin="normal"
        fullWidth
        label="Confirm Password"
        type="password"
        id="confirmPassword"
        {...register('confirmPassword', {
          required: 'Please confirm your password',
          validate: (value) =>
            value === newPassword || 'Passwords do not match',
        })}
        error={!!errors.confirmPassword}
        helperText={errors.confirmPassword?.message}
      />

      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2, py: 1.5 }}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          'Set New Password'
        )}
      </Button>
    </Box>
  );
};

export default NewPasswordForm;
